import { ArrowLeft } from "@phosphor-icons/react";
import { Button } from "@/components/ui/Button";

/**
 * 404 page. Simpler than the frontend app's (no mascot illustration — not
 * worth carrying that asset over for one internal-tool page).
 */
export function NotFoundPage() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 px-4 text-center">
      <h1 className="text-6xl font-bold text-primary">404</h1>
      <p className="text-xl text-muted-foreground">Page not found</p>
      <p className="max-w-md text-sm text-muted-foreground">
        The page you&apos;re looking for doesn&apos;t exist or has been moved.
      </p>
      <a href="/">
        <Button variant="outline">
          <ArrowLeft className="mr-2 h-4 w-4" />
          Back to Dashboard
        </Button>
      </a>
    </div>
  );
}
